/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TemplatePdfEnum } from './templatePdfEnum';


export interface TestPdfTemplateApiModel { 
    templateContent: string;
    data: TemplatePdfEnum;
}
export namespace TestPdfTemplateApiModel {
}


